import { useEffect } from "react";
import { Popover } from "@mui/material";
import { Link } from "react-router-dom";
import styles from "./notificationsPanel.module.css";
import { GROUPS, ICONS, NotificationRow, bundleNotifications } from "./NotificationRows";

// Notifications in the client preview: a glass panel under the bell. Same-day notifications
// of one kind are bundled into one row with short lines and a colour per kind.
export default function NotificationsPanel({ open, anchorEl, onClose, notifications, unread, onReadAll, onRefresh }) {
  useEffect(() => {
    if (open) onRefresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      anchorReference={anchorEl ? "anchorEl" : "anchorPosition"}
      anchorPosition={{ top: 56, left: window.innerWidth - 16 }}
      onClose={onClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      PaperProps={{ className: styles.panel, elevation: 0 }}
    >
      <header className={styles.head}>
        <div>
          <h2>Notifications</h2>
          <p>{unread ? `${unread > 99 ? "99+" : unread} unread` : "You are all caught up"}</p>
        </div>
        {unread > 0 && (
          <button type="button" className={styles.readAll} onClick={onReadAll}>
            Mark all as read
          </button>
        )}
      </header>

      <div className={styles.list}>
        {notifications.length === 0 ? (
          <div className={styles.empty}>
            <span className={styles.emptyIcon}>{ICONS.bell}</span>
            <b>No notifications yet</b>
            <span>Payments, top-ups and shipped orders show up here.</span>
          </div>
        ) : (
          GROUPS.map(([key, label]) => {
            const items = notifications.filter((n) => (n.arrived_in || "before_that") === key);
            if (!items.length) return null;
            return (
              <section key={key} className={styles.group}>
                <h3>{label}</h3>
                <ul>
                  {bundleNotifications(items).map((row) => (
                    <NotificationRow key={row.key} row={row} onClose={onClose} />
                  ))}
                </ul>
              </section>
            );
          })
        )}
      </div>

      <footer className={styles.foot}>
        <Link to="/customer/notifications" onClick={onClose}>
          View all notifications
        </Link>
      </footer>
    </Popover>
  );
}
